/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("gl", {
  Redo: "Refacer",
  Undo: "Desfacer",
  Cut: "Cortar",
  Copy: "Copiar",
  Paste: "Pegar",
  "Select all": "Seleccionar todo",
  "New document": "Novo documento",
  Ok: "Aceptar",
  Cancel: "Cancelar",
  "Visual aids": "Axudas visuais",
  Bold: "Negra",
  Italic: "Cursiva",
  Underline: "Subli\u00f1ado",
  Strikethrough: "Riscado",
  Superscript: "Super\u00edndice",
  Subscript: "Sub\u00edndice",
  "Clear formatting": "Limpar o formato",
  "Align left": "Ali\u00f1ar \u00e1 esquerda",
  "Align center": "Ali\u00f1ar ao centro",
  "Align right": "Ali\u00f1ar \u00e1 dereita",
  Justify: "Xustificar",
  "Bullet list": "Lista de vi\u00f1etas",
  "Numbered list": "Lista numerada",
  "Decrease indent": "Reducir a sangr\u00eda",
  "Increase indent": "Aumentar a sangr\u00eda",
  Close: "Pechar",
  Formats: "Formatos",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "O seu navegador non admite o acceso directo ao portapapeis. Empregue os atallos de teclado Ctrl+X/C/V no seu canto.",
  Headers: "Cabeceiras",
  "Header 1": "Cabeceira 1",
  "Header 2": "Cabeceira 2",
  "Header 3": "Cabeceira 3",
  "Header 4": "Cabeceira 4",
  "Header 5": "Cabeceira 5",
  "Header 6": "Cabeceira 6",
  Headings: "T\u00edtulo",
  "Heading 1": "T\u00edtulo 1",
  "Heading 2": "T\u00edtulo 2",
  "Heading 3": "T\u00edtulo 3",
  "Heading 4": "T\u00edtulo 4",
  "Heading 5": "T\u00edtulo 5",
  "Heading 6": "T\u00edtulo 6",
  Preformatted: "Preformatado",
  Div: "Div",
  Pre: "Pre",
  Code: "C\u00f3digo",
  Paragraph: "Par\u00e1grafo",
  Blockquote: "Bloque entre comi\u00f1as",
  Inline: "En li\u00f1a",
  Blocks: "Bloques",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Neste momento o pegado est\u00e1 definido en modo de texto simple. Os contidos p\u00e9garanse como texto sen formato ata que se active esta opci\u00f3n.",
  Fonts: "Tipos de letra",
  "Font Sizes": "Tama\u00f1o da letra",
  Class: "Clase",
  "Browse for an image": "Buscar unha imaxe",
  OR: "OU",
  "Drop an image here": "Soltar unha imaxe",
  Upload: "Cargar",
  Block: "Bloque",
  Align: "Ali\u00f1amento",
  Default: "Predeterminada",
  Circle: "Circulo",
  Disc: "Disco",
  Square: "Cadrado",
  "Lower Alpha": "Alfa min\u00fascula",
  "Lower Greek": "Grega min\u00fascula",
  "Lower Roman": "Romana min\u00fascula",
  "Upper Alpha": "Alfa mai\u00fascula",
  "Upper Roman": "Romana mai\u00fascula",
  "Anchor...": "Ancoraxe...",
  Name: "Nome",
  Id: "ID",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "O ID debe comezar cunha letra, seguida s\u00f3 por letras, n\u00fameros, gui\u00f3ns, puntos, dos puntos ou gui\u00f3ns baixos.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Ten cambios sen gardar. Confirma que quere sa\u00edr?",
  "Restore last draft": "Restaurar o \u00faltimo borrador",
  "Special characters...": "Caracteres especiais...",
  "Source code": "C\u00f3digo fonte",
  "Insert/Edit code sample": "Inserir/editar mostra de c\u00f3digo",
  Language: "Idioma",
  "Code sample...": "Mostra de c\u00f3digo...",
  "Color Picker": "Selector de cor",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "De esquerda a dereita",
  "Right to left": "De dereita a esquerda",
  "Emoticons...": "Emoticonas...",
  "Metadata and Document Properties": "Metadatos e propiedades do documento",
  Title: "T\u00edtulo",
  Keywords: "Palabras clave",
  Description: "Descrici\u00f3n",
  Robots: "Robots",
  Author: "Autor",
  Encoding: "Codificaci\u00f3n",
  Fullscreen: "Pantalla completa",
  Action: "Action",
  Shortcut: "Shortcut",
  Help: "Help",
  Address: "Address",
  "Focus to menubar": "Focus to menubar",
  "Focus to toolbar": "Focus to toolbar",
  "Focus to element path": "Focus to element path",
  "Focus to contextual toolbar": "Focus to contextual toolbar",
  "Insert link (if link plugin activated)":
    "Insert link (if link plugin activated)",
  "Save (if save plugin activated)": "Save (if save plugin activated)",
  "Find (if searchreplace plugin activated)":
    "Find (if searchreplace plugin activated)",
  "Plugins installed ({0}):": "Plugins installed ({0}):",
  "Premium plugins:": "Premium plugins:",
  "Learn more...": "Learn more...",
  "You are using {0}": "You are using {0}",
  Plugins: "Engadidos",
  "Handy Shortcuts": "Atallos \u00fatiles",
  "Horizontal line": "Li\u00f1a horizontal",
  "Insert/edit image": "Inserir/editar imaxe",
  "Image description": "Descrici\u00f3n da imaxe",
  Source: "Orixe",
  Dimensions: "Dimensi\u00f3ns",
  "Constrain proportions": "Restrinxir as proporci\u00f3ns",
  General: "Xeral",
  Advanced: "Avanzado",
  Style: "Estilo",
  "Vertical space": "Espazo vertical",
  "Horizontal space": "Espazo horizontal",
  Border: "Bordo",
  "Insert image": "Inserir imaxe",
  "Image...": "Imaxe...",
  "Image list": "Lista de imaxes",
  "Rotate counterclockwise": "Rotate counterclockwise",
  "Rotate clockwise": "Rotate clockwise",
  "Flip vertically": "Flip vertically",
  "Flip horizontally": "Flip horizontally",
  "Edit image": "Edit image",
  "Image options": "Image options",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  Crop: "Crop",
  Resize: "Resize",
  Orientation: "Orientation",
  Brightness: "Brightness",
  Sharpen: "Sharpen",
  Contrast: "Contrast",
  "Color levels": "Color levels",
  Gamma: "Gamma",
  Invert: "Invert",
  Apply: "Apply",
  Back: "Back",
  "Insert date/time": "Inserir data/hora",
  "Date/time": "Data/hora",
  "Insert/Edit Link": "Inserir/editar ligaz\u00f3n",
  "Insert/edit link": "Inserir/editar ligaz\u00f3n",
  "Text to display": "Texto que amosar",
  Url: "URL",
  "Open link in...": "Abrir a ligaz\u00f3n en...",
  "Current window": "Xanela actual",
  None: "Ning\u00fan",
  "New window": "Nova xanela",
  "Remove link": "Retirar a ligaz\u00f3n",
  Anchors: "Ancoraxes",
  "Link...": "Ligaz\u00f3n...",
  "Paste or type a link": "Pegue ou escriba unha ligaz\u00f3n",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "O URL que introduciu semella seren un enderezo de correo. Quere engadirlle o prefixo mailto: requirido?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "O URL que introduciu semella seren unha ligaz\u00f3n externa. Quere engadirlle o prefixo http:// requirido?",
  "Link list": "Lista de ligaz\u00f3ns",
  "Insert video": "Inserir v\u00eddeo",
  "Insert/edit video": "Inserir/editar v\u00eddeo",
  "Insert/edit media": "Inserir/editar medios",
  "Alternative source": "Orixe alternativa",
  "Alternative source URL": "URL da orixe alternativa",
  "Media poster (Image URL)": "Cartel multimedia (URL da imaxe)",
  "Paste your embed code below:": "Pegue embaixo o c\u00f3digo integrado:",
  Embed: "Integrado",
  "Media...": "Multimedia...",
  "Nonbreaking space": "Espazo irromp\u00edbel",
  "Page break": "Quebra de p\u00e1xina",
  "Paste as text": "Pegar como texto",
  Preview: "Vista previa",
  "Print...": "Imprimir...",
  Save: "Gardar",
  Find: "Buscar",
  "Replace with": "Substitu\u00edr con",
  Replace: "Substitu\u00edr",
  "Replace all": "Substitu\u00edr todo",
  Previous: "Anterior",
  Next: "Seguinte",
  "Find and replace...": "Atopar e substitu\u00edr...",
  "Could not find the specified string.":
    "Non foi pos\u00edbel atopar a cadea de texto especificada.",
  "Match case": "Distinguir mai\u00fasculas",
  "Find whole words only": "Atopar unicamente as palabras enteiras",
  "Spell check": "Corrector ortogr\u00e1fico",
  Ignore: "Ignorar",
  "Ignore all": "Ignorar todo",
  Finish: "Rematar",
  "Add to Dictionary": "Engadir ao dicionario",
  "Insert table": "Inserir t\u00e1boa",
  "Table properties": "Propiedades da t\u00e1boa",
  "Delete table": "Eliminar t\u00e1boa",
  Cell: "Cela",
  Row: "Fila",
  Column: "Columna",
  "Cell properties": "Propiedades da cela",
  "Merge cells": "Combinar celas",
  "Split cell": "Dividir celas",
  "Insert row before": "Inserir unha fila enriba",
  "Insert row after": "Inserir unha fila embaixo",
  "Delete row": "Eliminar fila",
  "Row properties": "Propiedades das filas",
  "Cut row": "Cortar fila",
  "Copy row": "Copiar fila",
  "Paste row before": "Pegar fila embaixo",
  "Paste row after": "Pegar fila enriba",
  "Insert column before": "Inserir columna \u00e1 esquerda",
  "Insert column after": "Inserir columna \u00e1 dereita",
  "Delete column": "Eliminar columna",
  Cols: "Cols.",
  Rows: "Filas",
  Width: "Largo",
  Height: "Alto",
  "Cell spacing": "Marxe entre celas",
  "Cell padding": "Marxe interior da cela",
  "Show caption": "Amosar subt\u00edtulo",
  Left: "Esquerda",
  Center: "Centro",
  Right: "Dereita",
  "Cell type": "Tipo de cela",
  Scope: "\u00c1mbito",
  Alignment: "Ali\u00f1amento",
  "H Align": "Ali\u00f1amento H",
  "V Align": "Ali\u00f1amento V",
  Top: "Arriba",
  Middle: "Medio",
  Bottom: "Abaixo",
  "Header cell": "Cela de cabeceira",
  "Row group": "Grupo de filas",
  "Column group": "Grupo de columnas",
  "Row type": "Tipo de fila",
  Header: "Cabeceira",
  Body: "Corpo",
  Footer: "Rodap\u00e9",
  "Border color": "Cor do bordo",
  "Insert template...": "Inserir modelo...",
  Templates: "Modelos",
  Template: "Modelo",
  "Text color": "Cor do texto",
  "Background color": "Cor do fondo",
  "Custom...": "Personalizado...",
  "Custom color": "Cor personalizado",
  "No color": "Sen cor",
  "Remove color": "Retirar a cor",
  "Table of Contents": "\u00cdndice de contidos",
  "Show blocks": "Amosar os bloques",
  "Show invisible characters": "Amosar caracteres invis\u00edbeis",
  "Word count": "Reconto de palabras",
  "Words: {0}": "Palabras: {0}",
  "{0} words": "{0} palabras",
  File: "Ficheiro",
  Edit: "Editar",
  Insert: "Inserir",
  View: "Ver",
  Format: "Formato",
  Table: "T\u00e1boa",
  Tools: "Ferramentas",
  "Powered by {0}": "Coa tecnolox\u00eda de {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "\u00c1rea de texto mellorado. Prema ALT-F9 para o men\u00fa. Prema ALT-F10 para a barra de ferramentas. Prema ALT-0 para a axuda",
  "Image title": "T\u00edtulo da imaxe",
  "Border width": "Largo do bordo",
  "Border style": "Estilo do bordo",
  Error: "Erro",
  Warn: "Aviso",
  Valid: "V\u00e1lido",
  "To open the popup, press Shift+Enter":
    "Para abrir a xanela emerxente, prema Mai\u00fas+Intro",
  "Rich Text Area. Press ALT-0 for help.":
    "\u00c1rea de texto mellorado. PremaALT-0 para obter axuda.",
  "System Font": "Tipo de letra do sistema",
  "Failed to upload image: {0}": "Produciuse un fallo ao cargar a imaxe: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Produciuse un fallo ao cargar a o engadido: {0} dende o URL {1}",
  "Failed to load plugin url: {0}":
    "Produciuse un fallo ao cargar a o URL do engadido: {0}",
  "Failed to initialize plugin: {0}":
    "Produciuse un fallo ao iniciar o engadido: {0}",
  example: "exemplo",
  Search: "Buscar",
  All: "Todo",
  Currency: "Moeda",
  Text: "Texto",
  Quotations: "Citas",
  Mathematical: "Matem\u00e1tico",
  "Extended Latin": "Latino extendido",
  Symbols: "S\u00edmbolos",
  Arrows: "Frechas",
  "User Defined": "Definido polo usuario",
  "dollar sign": "S\u00edmbolo do dolar",
  "currency sign": "S\u00edmbolo de moeda",
  "euro-currency sign": "S\u00edmbolo do euro",
  "colon sign": "S\u00edmbolo do col\u00f3n",
  "cruzeiro sign": "S\u00edmbolo do cruzeiro",
  "french franc sign": "S\u00edmbolo do franco franc\u00e9s",
  "lira sign": "S\u00edmbolo da lira",
  "mill sign": "S\u00edmbolo do mill",
  "naira sign": "S\u00edmbolo da naira",
  "peseta sign": "S\u00edmbolo da peseta",
  "rupee sign": "S\u00edmbolo da rupia",
  "won sign": "S\u00edmbolo do won",
  "new sheqel sign": "S\u00edmbolo do novo s\u00e9quel",
  "dong sign": "S\u00edmbolo do dong",
  "kip sign": "S\u00edmbolo do kip",
  "tugrik sign": "S\u00edmbolo do tugrik",
  "drachma sign": "S\u00edmbolo do dracma",
  "german penny symbol": "S\u00edmbolo do penique alem\u00e1n",
  "peso sign": "S\u00edmbolo do peso",
  "guarani sign": "S\u00edmbolo do guaran\u00ed",
  "austral sign": "S\u00edmbolo do austral",
  "hryvnia sign": "S\u00edmbolo do grivna",
  "cedi sign": "S\u00edmbolo do cedi",
  "livre tournois sign": "S\u00edmbolo da libre tournois",
  "spesmilo sign": "S\u00edmbolo do spesmilo",
  "tenge sign": "S\u00edmbolo do tengue",
  "indian rupee sign": "S\u00edmbolo da rupia india",
  "turkish lira sign": "S\u00edmbolo da lira turca",
  "nordic mark sign": "S\u00edmbolo do marco n\u00f3rdico",
  "manat sign": "S\u00edmbolo do manat",
  "ruble sign": "S\u00edmbolo do rublo",
  "yen character": "Car\u00e1cter do ien",
  "yuan character": "Car\u00e1cter do yuan",
  "yuan character, in hong kong and taiwan":
    "Car\u00e1cter do yuan, en Hong Kong e Taiwan",
  "yen/yuan character variant one": "Variante  1 do car\u00e1cter do ien/yuan",
  "Loading emoticons...": "Cargando emoticonas...",
  "Could not load emoticons": "Non foi pos\u00edbel cargar as emoticonas",
  People: "Xente",
  "Animals and Nature": "Animais e natureza",
  "Food and Drink": "Comida e bebida",
  Activity: "Actividade",
  "Travel and Places": "Viaxes e lugares",
  Objects: "Obxectos",
  Flags: "Bandeiras",
  Characters: "Caracteres",
  "Characters (no spaces)": "Caracteres (sen espazos)",
  "Error: Form submit field collision.":
    "Erro: conflito de campo ao enviar o formulario ",
  "Error: No form element found.":
    "Erro: non se atopou ning\u00fan elemento de formulario",
  Update: "Actualizar",
  "Color swatch": "Mostra de cores",
  Turquoise: "Turquesa",
  Green: "Verde",
  Blue: "Azul",
  Purple: "P\u00farpura",
  "Navy Blue": "Azul mari\u00f1o",
  "Dark Turquoise": "Turquesa escuro",
  "Dark Green": "Verde escuro",
  "Medium Blue": "Azul medio",
  "Medium Purple": "P\u00farpura medio",
  "Midnight Blue": "Azul noite",
  Yellow: "Amarelo",
  Orange: "Laranxa",
  Red: "Vermello",
  "Light Gray": "Gris claro",
  Gray: "Gris",
  "Dark Yellow": "Amarelo escuro",
  "Dark Orange": "Laranxa escuro",
  "Dark Red": "Vermello escuro",
  "Medium Gray": "Gris medio",
  "Dark Gray": "Gris escuro",
  Black: "Negro",
  White: "Branco",
  "Switch to or from fullscreen mode":
    "Activar ou desactivar o modo de pantalla completa",
  "Open help dialog": "Abrir o di\u00e1logo de axuda",
  history: "historial",
  styles: "estilos",
  formatting: "formatado",
  alignment: "ali\u00f1amento",
  indentation: "sangrado",
  "permanent pen": "rotulador permanente",
  comments: "comentarios",
  Anchor: "Ancoraxe",
  "Special character": "Car\u00e1cter especial",
  Color: "Cor",
  Emoticons: "Emoticonas",
  "Document properties": "Propiedades do documento",
  Image: "Imaxe",
  "Insert link": "Inserir ligaz\u00f3n",
  Target: "Destino",
  Link: "Ligaz\u00f3n",
  Poster: "Cartel",
  Media: "Medios",
  Print: "Imprimir",
  Prev: "Anterior",
  "Find and replace": "Buscar e substitu\u00edr",
  "Whole words": "Palabras completas",
  Spellcheck: "Corrector ortogr\u00e1fico",
  Caption: "Subt\u00edtulo",
  "Insert template": "Inserir modelo",
});
